module.exports = __webpack_public_path__ + "media/images/redesign-images/graduate-program/tcby-01-336123a9ba3ad48424b3c98a3c30fba2.webp";